<template>
  <div id="app">
    <!-- navigation bar -->
    <div class="nav-wrapper">
      <div id="nav">
        <!-- logo -->
        <a href="/">
          <img :src="require('@/assets/navbrand.svg')" alt="" height="45px" />
        </a>
        <!-- navigation links -->
        <div class="nav-links">
          <router-link v-for="link in links" :key="link.id" :to="link.url">
            {{ link.name }}
          </router-link>
          <a @click.prevent="_contactSection()" href>Contact Us</a>
        </div>
        <!-- side navbar controller -->
        <img
          :src="require('@/assets/menu.svg')"
          class="side-nav-btn"
          height="30px"
          alt="hamburger menu"
          @click.prevent="clicked = !clicked"
        />
      </div>
    </div>
    <!-- side navbar for mobile view -->
    <transition name="ease-in">
      <div class="side-nav" v-if="clicked">
        <div class="mob-links">
          <a
            href="#"
            v-for="l in links"
            :key="l.id"
            @click="$router.push({ name: l.url }), (clicked = false)"
          >
            {{ l.name }}
          </a>
          <!-- <router-link v-for="link in links" :key="link.id" :to="link.url">
            {{ link.name }}
          </router-link> -->
          <a @click.prevent="_contactSection()" href>Contact Us</a>
        </div>
        <!-- close the sidenav -->
        <img
          :src="require('@/assets/close.svg')"
          height="32px"
          @click.prevent="clicked = !clicked"
          alt="close sidebar"
          class="closer"
        />
      </div>
    </transition>
    <!-- line breaks for padding -->
    <br /><br />
    <!-- route view -->
    <router-view />
    <!-- end of router view -->
    <footer>
      <!-- footer grid -->
      <div class="footer-wrapper">
        <div class="links">
          <h2>Quick Links</h2>
          <!-- navigation links -->
          <router-link v-for="link in links" :key="link.id" :to="link.url">
            {{ link.name }}
          </router-link>
          <a @click.prevent="_contactSection()" href>Contact Us</a>
        </div>
        <!-- contact information -->
        <div class="contact">
          <h2>Contact us</h2>
          <h4>Email:</h4>
          <a href="mailto:admin@connectskills.com.ng">
            admin@connectskills.com.ng
          </a>
          <h4>Phone:</h4>
          <a href="tel:+23409055754858"> 0905-575-4858 </a>
        </div>
        <!-- newsletter sub -->
        <div class="newsletter" id="newsletter">
          <h2>Newsletter</h2>
          <form
            class="newsletter"
            action="https://docs.google.com/forms/u/1/d/e/1FAIpQLSetThB8-yiatnu77EDdrTppuhr-dnq9ZYRNyEYGvjE-euG62g/formResponse"
          >
            <input
              type="text"
              placeholder="Enter full name"
              name="entry.1194384170"
              required
            />
            <input
              type="email"
              placeholder="Enter email"
              name="entry.1692060885"
              required
            />
            <button class="btn btn-outline" type="submit">Subscribe!</button>
          </form>
        </div>
      </div>
      <div class="copyright">Copyright &copy; 2019 || CSVC.</div>
    </footer>
  </div>
</template>

<style>
/************** MAIN STYLES ************/

html body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  line-height: 2em;
  --primary-color: #f02529;
  --secondary-color: rgb(211, 211, 211);
  --tetiary-color: rgb(42, 85, 204);
  --footer-color: rgb(71, 74, 77);
}

/*************** NAVIGATION BAR STYLES *************/

#nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-evenly;
}

#nav a {
  text-decoration: none;
  font-weight: lighter;
  color: var(--secondary-color);
  margin-left: 1rem;
}

div.nav-wrapper {
  padding-top: 0.5rem;
  background-color: var(--primary-color);
  width: 100%;
  position: fixed;
  height: 60px;
  top: 0;
  left: 0;
}

#nav a.router-link-exact-active {
  color: white;
  font-weight: bold;
}

.nav-wrapper .side-nav-btn {
  display: none;
}

/* media query for side nav */
@media only screen and (max-width: 998px) {
  #nav .nav-links {
    display: none;
  }
  .nav-wrapper .side-nav-btn {
    display: block;
    margin-right: 1rem;
  }
  #nav {
    justify-content: space-between;
  }
}

/*************** SIDE NAV STYLES ***************/
div.side-nav {
  position: fixed;
  height: 700px;
  top: 0;
  right: 0;
  width: 60vw;
  background-color: var(--primary-color);
  padding: 2rem;
  box-shadow: -2px -4px 30px;
}
.side-nav .mob-links {
  display: flex;
  flex-direction: column;
}

.side-nav a {
  color: white;
  font-size: 24px;
  text-decoration: none;
  margin: 0.25rem 0;
}

.side-nav a.router-link-exact-active {
  color: white;
  font-weight: bold;
}

.side-nav .closer {
  position: absolute;
  top: 20px;
  right: 20px;
}

/* transitions */
.ease-in-enter,
.ease-in-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.ease-in-enter-active,
.ease-in-leave-active {
  transition: all 1s;
}

/*************** FOOTER STYLES ******************/

footer {
  background-color: var(--footer-color);
  color: rgb(129, 129, 129);
}

footer a {
  margin-bottom: 1rem;
  text-decoration: none;
  color: white;
}

footer .footer-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 0.5rem;
  margin: 0 2rem;
}

footer .links {
  grid-column: 1/2;
  display: flex;
  flex-direction: column;
}

footer .contact {
  grid-column: 2/3;
}

footer .contact h4 {
  color: lightgray;
}

footer .copyright {
  color: whitesmoke;
  height: 40px;
  display: flex;
  background-color: var(--tetiary-color);
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
}

form.newsletter {
  display: flex;
  flex-direction: column;
}

form.newsletter input {
  border-radius: 1rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
}

@media only screen and (max-width: 998px) {
  footer .link {
    grid-column: 1/4;
  }
  footer .contact {
    grid-column: 1/4;
  }
}

/*************** BUTTON STYLES **************/
.btn {
  padding: 0.5rem 1rem;
  border-radius: 1rem;
}
.btn.btn-dark {
  background-color: var(--footer-color);
  color: white;
  border-width: 0;
}
.btn.btn-light {
  background-color: whitesmoke;
  color: var(--footer-color);
}
.btn.btn-outline {
  color: whitesmoke;
  background-color: rgba(255, 255, 255, 0);
  border-width: 1px;
  border-color: whitesmoke;
  border-style: solid;
}

.btn.btn-outline-dark {
  color: var(--tetiary-color);
  background-color: rgba(255, 255, 255, 0);
  border-width: 1px;
  border-color: var(--tetiary-color);
  border-style: solid;
}
/******** PAGE HEADER *************/
div.page-header {
  height: 20vh;
  background-color: var(--tetiary-color);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: whitesmoke;
  padding: 0 2rem;
}
/********* PAGE CONTENT **********/
section.page-content {
  margin: 2rem;
}
</style>

<script>
export default {
  data() {
    return {
      clicked: false,
      links: [
        { name: "Home", url: "/" },
        { name: "About", url: "about" },
        { name: "Services", url: "services" }
        // { name: "Clients", url: "/about" },
        // { name: "CSR", url: "/about" },
        // { name: "Gallery", url: "/about" }
      ]
    };
  },
  methods: {
    _contactSection: function() {
      this.clicked = false;
      return this.$router.push({ name: "home", hash: "#contact" });
      // window.alert('to hash')
    }
  }
};
</script>
